module.exports = __webpack_public_path__ + "img/fig1.5b81f613.png";